<h2 style="margin:5px 0 10px 0;">Create a New ItemType</h2>
<form
    [formGroup]="form"
    novalidate
    (ngSubmit)="OnSubmit()"
>
    <table cellspacing="2" class="attribute-full-width">
        <tr>
            <td>
                <mat-form-field>
                    <input
                        [attr.data-testid]="'itemtype_name_text'"
                        formControlName="name"
                        matInput
                        placeholder="ItemType Name"
                        required
                        [pattern]="spaceValidatorPattern"
                    />
                    <mat-error *ngIf="form.controls['name'].invalid">Please enter a Name</mat-error>
                </mat-form-field>
            </td>
            <td>
                <mat-form-field>
                    <input
                        [attr.data-testid]="'itemtype_tag_text'"
                        formControlName="tag"
                        matInput
                        pattern="^[A-Z_0-9]*$"
                        placeholder="ItemType Tag"
                        required
                        (focusout)="findTagExists()"
                    />
                    <mat-error *ngIf="form.controls['tag'].invalid && !form.controls['tag'].value">
                        Please enter a Standard Tag
                    </mat-error>
                    <mat-error *ngIf="form.controls['tag'].errors?.pattern && form.controls['tag'].value">
                        Please enter a Valid Standard Tag
                    </mat-error>
                    <mat-error *ngIf="form.controls['tag'].errors?.tagExists && form.controls['tag'].touched">
                        Tag already exists! Create a new one.
                    </mat-error>
                </mat-form-field>
            </td>
        </tr>
        <tr>
            <td>
                <mat-form-field>
                    <mat-select
                        [attr.data-testid]="'item_class_type_select'"
                        formControlName="classTag"
                        placeholder="Item Class Type"
                        required
                    >
                        <mat-option
                            *ngFor="let itemTypeClass of itemTypeClasses | async"
                            [attr.data-testid]="itemTypeClass.className + '_option'"
                            [value]="itemTypeClass.classTag"
                        >
                            {{ itemTypeClass.className }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.controls['classTag'].invalid">Please Select a Value</mat-error>
                </mat-form-field>
            </td>
            <td>
                <mat-form-field>
                    <textarea
                        #message
                        [attr.data-testid]="'description_textarea'"
                        formControlName="description"
                        matInput
                        maxlength="256"
                        placeholder="Description"
                    ></textarea>
                    <mat-hint align="end">{{ message.value.length }} / 256</mat-hint>
                </mat-form-field>
            </td>
        </tr>
    </table>
    <div  style="margin-top: 30px;" class="flex-center-center">
        <button
            [attr.data-testid]="'cancel_button'"
            class="button-color"
            mat-raised-button
            matTooltip="Cancel creating ItemType"
            style="margin-right: 60px;"
            type="button"
            (click)="onNoClick()"
        >Cancel</button>
        <button
            [attr.data-testid]="'submit_button'"
            class="button-color"
            [disabled]="isReadOnly | async"
            mat-raised-button
            matTooltip="Submit ItemType"
            type="submit"
        >Save</button>
    </div>
</form>
